const CHANNEL_NAME = 'chatkit-sync';
const SYNC_EVENTS = [
  'chatkit.sync.response.start',
  'chatkit.sync.response.end',
  'chatkit.sync.thread.change',
  'chatkit.sync.end-chat'
];

let channel = null;

function handleMessage(event) {
  const { type, detail } = event.data;

  if (SYNC_EVENTS.includes(type)) {
    document.dispatchEvent(new CustomEvent(type, { detail }));
  }
}

export function setup() {
  if (!('BroadcastChannel' in window)) return;

  channel = new BroadcastChannel(CHANNEL_NAME);
  channel.addEventListener('message', handleMessage);
}

export function broadcast(type, detail = null) {
  if (!channel) return;

  channel.postMessage({ type, detail });
}

export function cleanup() {
  if (!channel) return;

  channel.removeEventListener('message', handleMessage);
  channel.close();
  channel = null;
}
